/**
 * How a customer record came to exist. `null` on a customer row means it
 * predates this field (or the schema's demo/seed helpers) — treated as
 * "unknown" everywhere this is filtered or displayed, not as an error.
 */
export const CUSTOMER_ORIGINS = ['admin', 'web', 'kiosk', 'import'];
//# sourceMappingURL=customer-origins.js.map